var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 55H7.5C6.475 55 5.625 54.15 5.625 53.125C5.625 52.1 6.475 51.25 7.5 51.25H52.5C53.525 51.25 54.375 52.1 54.375 53.125C54.375 54.15 53.525 55 52.5 55Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5499 8.70015C42.6999 3.85015 37.9499 3.72515 32.9749 8.70015L29.9499 11.7251C29.6999 11.9751 29.5999 12.3751 29.6999 12.7251C31.5999 19.3502 36.8999 24.6501 43.5249 26.5501C43.6249 26.5751 43.7249 26.6002 43.8249 26.6002C44.0999 26.6002 44.3499 26.5002 44.5499 26.3001L47.5499 23.2752C50.0249 20.8252 51.2249 18.4501 51.2249 16.0501C51.2499 13.5751 50.0499 11.1751 47.5499 8.70015Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0251 28.825C38.3001 28.475 37.6001 28.125 36.9251 27.725C36.3751 27.4 35.8501 27.05 35.3251 26.675C34.9001 26.4 34.4001 26 33.9251 25.6C33.8751 25.575 33.7001 25.425 33.5001 25.225C32.6751 24.525 31.7501 23.625 30.9251 22.625C30.8501 22.575 30.7251 22.4 30.5501 22.175C30.3001 21.875 29.8751 21.375 29.5001 20.8C29.2001 20.425 28.8501 19.875 28.5251 19.325C28.1251 18.65 27.7751 17.975 27.4251 17.275C27.1982 16.7888 27.0028 16.3131 26.8253 15.8548C26.6937 15.5148 26.2563 15.4188 25.9985 15.6765L10.8501 30.825C10.5251 31.15 10.2251 31.775 10.1501 32.2L8.80006 41.775C8.55006 43.475 9.02507 45.075 10.0751 46.15C10.9751 47.025 12.2251 47.5 13.5751 47.5C13.8751 47.5 14.1751 47.475 14.4751 47.425L24.0751 46.075C24.5251 46 25.1501 45.7 25.4501 45.375L40.5914 30.2337C40.8509 29.9741 40.752 29.5317 40.41 29.3984C39.9617 29.2236 39.509 29.0347 39.0251 28.825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.81d5326b23da55d415c7602d9604c27b.svg";
export { ForwardRef as ReactComponent };